import './styles.scss'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import Switch from 'react-switch'
import ReactTooltip from 'react-tooltip'
import flagEnvDisplay from 'constants/flagEnvDisplay'
import { getStaticImage } from 'utils/statics'
import ModalPlan from 'components/ModalPlan'

const VACard = (props) => {
  const {
    consoleId,
    updateBotHeader,
    checkSmartChatModule,
    smartChatChecked,
    checked,
    setChecked,
    generativeChecked,
    setGenerativeChecked,
    assistedAIChecked,
    setAssistedAIChecked,
    openSchedule,
    getModelStatus,
    checkSmartChatEcommerceModule,
    smartChatEcommerceChecked,
    toggleGeneratedResponsesModal,
    companyId,
  } = props

  const currentPlan = useSelector((store) => store.currentPlan)
  const modules = useSelector((store) => store.modules)
  const [isOpenPlanModal, setIsOpenPlanModal] = useState(false)

  return (
    <div className='av-card'>
      <div className='title-section'>
        <div className='title'>{I18n.t('nav_configurations_console_faqs')}</div>
        <div className='subtitle'>{I18n.t('faq_console_header_title')}</div>
      </div>
      <div className='options-container'>
        {
          flagEnvDisplay.displayEcommerceAV(companyId) && ( //@TODO eliminar tras la subida del ecommerce a PRO
            <div className='switch-container'>
              <div className='switch-title'>
                <figure className='switch-icon'>
                  <img src={getStaticImage('/chatbot/orange-brand/smartchat-ecommerce.svg')} alt='SmartChat Ecommerce Bot' />
                </figure>
                <p>{I18n.t('dashboard_smartchat-ecommerce')}</p>
                <i className='fa fa-info-circle' data-tip={I18n.t('dashboard_smartchat-ecommerce')}></i>
              </div>
              <Switch
                onChange={() => checkSmartChatEcommerceModule(consoleId)}
                checked={modules.smartChatEcommerce?.isActive ? smartChatEcommerceChecked : false }
                onColor='#E87721'
                onHandleColor='#fff'
                uncheckedIcon={false}
                checkedIcon={false}
                className='switch'
              />
            </div>
          )
        }
        <div className='switch-container'>
          <div className='switch-title'>
            <figure className='switch-icon'>
              <img src={getStaticImage('/chatbot/orange-brand/bot-smarchat.svg')} alt='SmartChat Bot' />
            </figure>
            <p>{I18n.t('dashboard_smartchat')}</p>
            <i
              className='fa fa-info-circle'
              data-tip={I18n.t('faq_console_switch_tooltip_smartchat')}
            ></i>
          </div>
          <Switch
            onChange={() => {
              checkSmartChatModule(consoleId)
            }}
            checked={modules.smartChat?.isActive ? smartChatChecked : false}
            onColor='#E87721'
            onHandleColor='#fff'
            uncheckedIcon={false}
            checkedIcon={false}
            className='switch'
          />
        </div>
        <div className='switch-container'>
          <div className='switch-title'>
            <figure className='switch-icon'>
              <img src={getStaticImage('/chatbot/orange-brand/bot-response.svg')} alt='Responses Bot' />
            </figure>
            <p>{I18n.t('dashboard_automatic-responses')}</p>
            <i className='fa fa-info-circle' data-tip={I18n.t('faq_console_switch_tooltip_bot')}></i>
          </div>
          <Switch
            onChange={(c) => {
              updateBotHeader(consoleId, { isActive: c })
              setChecked(c)
            }}
            checked={modules.faqConsole?.isActive ? checked : false}
            onColor='#E87721'
            onHandleColor='#fff'
            uncheckedIcon={false}
            checkedIcon={false}
            className='switch'
          />
        </div>
        <div className='switch-container'>
          <div className='switch-title'>
            <figure className='switch-icon'>
              <img
                src={getStaticImage('/icons/orange-brand/icon-bot-generated-responses-secondary.svg')}
                alt='Generative VA'
              />
            </figure>
            <p>{I18n.t('dashboard_generated-responses')}</p>
            <i
              className='fa fa-info-circle'
              data-tip={I18n.t('faq_console_switch_tooltip_generated-responses')}
            ></i>
          </div>
          <button
            className='av-card__config-btn'
            onClick={(e) => {
              if (!currentPlan?.limits?.faqGenerative) {
                setIsOpenPlanModal(true)
              } else {
                toggleGeneratedResponsesModal(e)
              }
            }}
          >
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-settings-secondary.svg')} alt='Configuration' />
            </figure>
          </button>
          <Switch
            onChange={c => {
              if (!currentPlan?.limits?.faqGenerative) {
                setIsOpenPlanModal(true)
              } else {
                updateBotHeader(consoleId, { generative: c })
                setGenerativeChecked(c)
              }
            }}
            checked={modules.faqGenerative?.isActive ? !!generativeChecked : false}
            uncheckedIcon={false}
            checkedIcon={false}
            onColor='#E87721'
            onHandleColor='#fff'
            className='switch'
          />
        </div>
        <div className='switch-container'>
          <div className='switch-title'>
            <figure className='switch-icon'>
              <img src={getStaticImage('/chatbot/orange-brand/bot-assistant.svg')} alt='Assistant Bot' />
            </figure>
            <p>{I18n.t('dashboard_operator-assistance')}</p>
            <i
              className='fa fa-info-circle'
              data-tip={I18n.t('faq_console_switch_tooltip_assistant')}
            ></i>
          </div>
          <Switch
            onChange={(c) => {
              updateBotHeader(consoleId, { operatorAssistance: c })
              setAssistedAIChecked(c)
            }}
            checked={modules.faqConsoleAssistant?.isActive ? assistedAIChecked : false}
            uncheckedIcon={false}
            checkedIcon={false}
            onColor='#E87721'
            onHandleColor='#fff'
            className='switch'
          />
        </div>
      </div>
      <div className='schedule-container'>
        <div className='schedule-item' onClick={openSchedule}>
          <i className='fa fa-clock-o fa-lg'></i>
          {I18n.t('dashboard_modify-schedule')}
        </div>
      </div>
      {getModelStatus()}
      <ReactTooltip place='right' multiline={true} />
      <ModalPlan
        isOpen={isOpenPlanModal}
        toggle={() => setIsOpenPlanModal(false)}
      />
    </div>
  )
}

export default VACard
